import Dialog from "dialog";
import template from "../html/dialog-config-leds.html";
import css from "../css/dialog-config-leds.css";

class ConfigLEDsDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-leds", ConfigLEDsDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	checkboxLEDRed_click(event) {
		server.rcall("RM_LEDs_setRed", this.checkboxLEDRed.checked).catch(function(result) {
			alert(result);
		});
	}
	checkboxLEDYellow_click(event) {
		server.rcall("RM_LEDs_setYellow", this.checkboxLEDYellow.checked).catch(function(result) {
			alert(result);
		});
	}
	checkboxLEDGreen_click(event) {
		server.rcall("RM_LEDs_setGreen", this.checkboxLEDGreen.checked).catch(function(result) {
			alert(result);
		});
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.leds.id;
		this.textboxDeviceStatus.value = devices.leds.status;
		this.checkboxLEDRed.checked = devices.leds.red;
		this.checkboxLEDYellow.checked = devices.leds.yellow;
		this.checkboxLEDGreen.checked = devices.leds.green;
	}
	buttonClose_click(event) {
		this.close();
	}
}

ConfigLEDsDialog.constructor();

export default ConfigLEDsDialog;